import { MstGenericResponse } from '@mst-fe/shared';

import { showErrorNotification } from '../_shared/views/Notifications';

export interface ErrorNotification {
  message: string;
  description?: string | undefined;
  deduplicationKey?: string;
}

export function handleError(error: ErrorNotification | undefined) {
  if (error) {
    showErrorNotification(error);
  }
}

export function handleAPIResponse(response: MstGenericResponse | undefined): boolean {
  if (!response) {
    showErrorNotification({ message: 'Error contacting server.' });
    return true;
  }

  if (!response.ok) {
    showErrorNotification({ message: response.error });
    return true;
  }

  return false;
}
